document.addEventListener('DOMContentLoaded', () => {
  let initialPage = 1;
  let pagesCount;
  let resetContent = true;
  const fetchAndRenderBlogPosts = async (searchQuery) => {
    try {
      const response = await fetch(`/search?q=${encodeURIComponent(searchQuery)}&type=article&options[unavailable_articles]=hide&options[prefix]=last&page=${initialPage}`);
      const blogPostsHtml = await response.text();
      
      const tempContainer = document.createElement('div');
      tempContainer.innerHTML = blogPostsHtml;

      const customSliderComponent = tempContainer.querySelector('#custom-slider-component');
      const blogPostsSection = document.getElementById('blogPostsSection');
      if (resetContent) {
        blogPostsSection.innerHTML = '';
      }
    
      if (customSliderComponent) {
        pagesCount = customSliderComponent.getAttribute('data-pages');
        blogPostsSection.appendChild(customSliderComponent);
      } else {
        blogPostsSection.innerHTML = '';
      }

      document.querySelector('.blog-search_load-more').style.display = ((initialPage == pagesCount || !customSliderComponent) ? 'none' : 'block');

    } catch (error) {
      console.error('Error fetching blog posts:', error);
    }
  };
  
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };
  
  if(document.getElementById('searchInput')) {
    document.getElementById('searchInput').addEventListener('input', debounce((event) => {
      resetContent = true;
      initialPage = 1;
      const searchQuery = event.target.value;
      fetchAndRenderBlogPosts(searchQuery);
    }, 500));
  } 

  if (document.querySelector('.blog-search_load-more')) {
    document.querySelector('.blog-search_load-more').addEventListener('click', () => {
      resetContent = false;
      if (initialPage < pagesCount) {
        initialPage += 1;
        fetchAndRenderBlogPosts(document.getElementById('searchInput').value);
      }
    })
  }
})

